module.exports = __webpack_public_path__ + "img/Assists.5043cae7.svg";